/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { NotificationRegistrationStatusUpdateRequest } from '../model/notificationRegistrationStatusUpdateRequest';
import { NotificationRegistrationStatusUpdateResponse } from '../model/notificationRegistrationStatusUpdateResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class NotificationRegistrationStatusService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * updateNotificationRegistrationStatus
     * Updates the status of a notification registration. &lt;p&gt;Requires WRITE permission on namespace&lt;/p&gt;
     * @param namespace The namespace of the notification registration.
     * @param notificationName The name of the notification registration.
     * @param notificationRegistrationStatusUpdateRequest The request to update the status.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public notificationRegistrationStatusUpdateNotificationRegistrationStatus(namespace: string, notificationName: string, notificationRegistrationStatusUpdateRequest: NotificationRegistrationStatusUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<NotificationRegistrationStatusUpdateResponse>;
    public notificationRegistrationStatusUpdateNotificationRegistrationStatus(namespace: string, notificationName: string, notificationRegistrationStatusUpdateRequest: NotificationRegistrationStatusUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationRegistrationStatusUpdateResponse>>;
    public notificationRegistrationStatusUpdateNotificationRegistrationStatus(namespace: string, notificationName: string, notificationRegistrationStatusUpdateRequest: NotificationRegistrationStatusUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationRegistrationStatusUpdateResponse>>;
    public notificationRegistrationStatusUpdateNotificationRegistrationStatus(namespace: string, notificationName: string, notificationRegistrationStatusUpdateRequest: NotificationRegistrationStatusUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (namespace === null || namespace === undefined) {
            throw new Error('Required parameter namespace was null or undefined when calling notificationRegistrationStatusUpdateNotificationRegistrationStatus.');
        }
        if (notificationName === null || notificationName === undefined) {
            throw new Error('Required parameter notificationName was null or undefined when calling notificationRegistrationStatusUpdateNotificationRegistrationStatus.');
        }
        if (notificationRegistrationStatusUpdateRequest === null || notificationRegistrationStatusUpdateRequest === undefined) {
            throw new Error('Required parameter notificationRegistrationStatusUpdateRequest was null or undefined when calling notificationRegistrationStatusUpdateNotificationRegistrationStatus.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<NotificationRegistrationStatusUpdateResponse>(`${this.configuration.basePath}/notificationRegistrationStatus/namespaces/${encodeURIComponent(String(namespace))}/notificationNames/${encodeURIComponent(String(notificationName))}`,
            notificationRegistrationStatusUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
